/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useEffect, useState } from 'react';

import ErrorMessage from '../ErrorMessage';
import './style.scss';
import CustomLink from '../CustomLink';

/**
 * Input
 * @param {String} error      either 'error' as String or 'errors' as an array of errors
 * @param {[String]} errors   either 'error' as String or 'errors' as an array of errors
 * @param {Boolean} hasError  to just change the border colour when error message handler in the upper layer
 * @param {String} id*     ⚠️ required for the correct behaviour (label)
 * @param {String} name
 * @param {String} type    text|number|date|datetime-local|time|week|month|tel|url
 *                         |email|password|search|checkbox|color|textarea
 * @param {String} label
 * @param {String} sublabel
 * @param {String/Number/Date} value
 * @param {Date|Number} min date for date type
 * @param {Date|Number} max date for date type
 * @param {String} placeholder
 * @param {Boolean} isBoldLabel
 * @param {(term) => {}} onSearch
 * @param {(e) => {}} onChange
 * @param {(e) => {}} onBlur
 * @param {String} customClassNames
 * @param {Number} digitsLimit only for number type to limit max digits
 */

const Input = ({
    error,
    errors,
    hasError,
    id,
    name,
    type,
    label,
    sublabel,
    value,
    min,
    max,
    placeholder,
    disabled = false,
    isBoldLabel,
    customClassNames,
    onSearch = () => { },
    onChange = () => { },
    onBlur = () => { },
    onFocus = () => { },
    disableAutofill = false,
    linkLabel,
    linkURL,
    digitsLimit,
    autoComplete,
    ariaLabel,
    inputAriaProps = {},
}) => {
    const mainInputRef = useRef(null);
    const [localValue, setLocalValue] = useState(value || '');
    const [isPasswordVisible, setIsPasswordvisible] = useState(false);

    useEffect(() => {
        (value !== undefined && value !== null) && setLocalValue?.(value);
    }, [value]);

    const onSearchClick = () => {
        localValue && onSearch?.(value);
        !localValue && mainInputRef?.current?.focus();
    };

    // Accessibility: expose validation state and (where there is no visible
    // <label>) an accessible name to assistive tech. Purely programmatic — no
    // visual effect.
    const hasErrorState = !!(error || hasError || errors?.length);
    const errorId = id ? `${id}-error` : undefined;
    const a11yProps = {
        'aria-invalid': hasErrorState || undefined,
        'aria-describedby': (hasErrorState && errorId) ? errorId : undefined,
        'aria-label': ariaLabel || undefined,
        // Caller-supplied ARIA (e.g. combobox role/state) forwarded to the input.
        ...inputAriaProps,
    };
    const resolvedAutoComplete = disableAutofill
        ? 'one-time-code'
        : (autoComplete || undefined);

    return (
        <div className={`zelp-input ${error || hasError || errors?.length
            ? 'zelp-input__error' : ''}
            ${type === 'checkbox' ? 'zelp-input__checkbox' : ''} ${customClassNames || ''}`}>
            {type === 'checkbox'
                && (
                    <label htmlFor={id} className="zelp-input_checkbox-label">
                        <input
                            type="checkbox"
                            checked={localValue}
                            onChange={e => {
                                setLocalValue(e.target.checked);
                                onChange?.(e);
                            }}
                            onBlur={e => { onBlur?.(e); }}
                            id={id}
                            name={name}
                            ref={mainInputRef}
                            disabled={disabled || false} />

                        {localValue ? (
                            <>
                                <i
                                    className={`zelpicon zelpicon-checkbox-cb ${disabled
                                        ? 'checkbox-icon__disabled' : ''}`}
                                    aria-hidden="true" />
                                <i
                                    className={`zelpicon zelpicon-checkbox-c ${disabled
                                        ? 'checkbox-icon__disabled' : ''}`}
                                    aria-hidden="true" />
                                {/* <i className={`checkbox-icon zelpicons zelpicons-checked-checkbox ${disabled
                            ? 'checkbox-icon__disabled' : ''}`} aria-hidden="true" /> */}
                                {/* <i className={`checkbox-icon zelpicons zelpicons-empty-checkbox ${disabled
                                    ? 'checkbox-icon__disabled' : ''}`} aria-hidden="true" /> */}
                            </>
                        ) : <i
                            className={`zelpicon zelpicon-checkbox-eb ${disabled
                                ? 'checkbox-icon__disabled' : ''}`}
                            aria-hidden="true" />}
                        <span className={`zelp-input_checkbox-label_text ${disabled
                            ? 'zelp-input_checkbox-label_text__disabled' : ''}`}>
                            {label || ''}
                        </span>
                    </label>)}

            {label && type !== 'checkbox' && (linkLabel && linkURL
                ? (
                    <div className="zelp-input_label-with-link-container">
                        <label
                            htmlFor={id}
                            className={`zelp-input_label ${isBoldLabel ? 'zelp-input_label__bold' : ''}`}>
                            {label || ''}
                        </label>
                        <CustomLink to={linkURL} className="zelp-input_link" isInline>{linkLabel}</CustomLink>
                    </div>
                )
                : (
                    <label
                        htmlFor={id}
                        className={`zelp-input_label ${isBoldLabel ? 'zelp-input_label__bold' : ''}`}>
                        {label || ''}
                    </label>
                ))}

            {sublabel && type !== 'checkbox' && (
                <span
                    className="zelp-input_sublabel">
                    {sublabel || ''}
                </span>
            )}
            {type === 'color' && <input
                type="color"
                value={localValue}
                onChange={e => {
                    setLocalValue(e.target.value);
                    onChange?.(e);
                }}
                onBlur={e => { onBlur?.(e); }}
                id={id}
                name={name}
                {...a11yProps}
                ref={mainInputRef} />}

            {(type === 'date' || type === 'datetime-local') && (
                <div className="zelp-input_input">
                    <input
                        className={`
                            ${mainInputRef?.current?.value?.substring(0, 4).length === 4 &&
                                !Number.isNaN(
                                    mainInputRef?.current?.value?.substring(0, 4)
                                ) ? '' : 'zelp-input_input_date_year_placeholder'}
                            ${mainInputRef?.current?.value?.substring(5, 7).length === 2 &&
                                !Number.isNaN(
                                    mainInputRef?.current?.value?.substring(5, 7)
                                ) ? '' : 'zelp-input_input_date_month_placeholder'}
                            ${mainInputRef?.current?.value?.substring(8, 10).length === 2 &&
                                !Number.isNaN(
                                    mainInputRef?.current?.value?.substring(8, 10)
                                ) ? '' : 'zelp-input_input_date_day_placeholder'}
                        `}
                        type={type}
                        min={min}
                        max={max}
                        value={localValue}
                        onChange={e => {
                            setLocalValue(e.target.value);
                            onChange?.(e);
                        }}
                        onBlur={e => { onBlur?.(e); }}
                        onFocus={e => { onFocus?.(e); }}
                        id={id}
                        placeholder={placeholder || ''}
                        name={name}
                        {...a11yProps}
                        ref={mainInputRef} />
                </div>)}

            {(!type
                || type === 'text'
                || type === 'time'
                || type === 'week'
                || type === 'month'
                || type === 'tel'
                || type === 'url'
                || type === 'email'
                || type === 'search'
                || type === 'password')
                && (
                    <div className="zelp-input_input">
                        <input
                            autoComplete={resolvedAutoComplete}
                            type={type === 'password' ? (isPasswordVisible ? 'text' : 'password') : (type || 'text')}
                            value={localValue}
                            onChange={e => {
                                setLocalValue(e.target.value);
                                onChange?.(e);
                            }}
                            onBlur={e => { onBlur?.(e); }}
                            onFocus={e => { onFocus?.(e); }}
                            id={id}
                            minLength={min}
                            maxLength={max}
                            placeholder={placeholder || ''}
                            name={name}
                            {...a11yProps}
                            ref={mainInputRef} />
                        {type === 'password'
                            ? (
                                <i
                                    role="button"
                                    tabIndex={0}
                                    aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
                                    aria-pressed={isPasswordVisible}
                                    className={`zelp-input_input_password-visibility
                     zelpicon ${isPasswordVisible ? 'zelpicon-view' : 'zelpicon-hide'}`}
                                    onClick={() => { setIsPasswordvisible(prev => !prev); }}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setIsPasswordvisible(prev => !prev);
                                        }
                                    }} />)
                            : ''}
                        {type === 'search'
                            && <i
                                role="button"
                                tabIndex={0}
                                aria-label="Search"
                                className="zelpicons zelpicons-search"
                                onClick={onSearchClick}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        onSearchClick();
                                    }
                                }} />}
                    </div>)}

            {type === 'number'
                && (
                    <div className="zelp-input_input">
                        <input
                            type="number"
                            pattern="\d*"
                            value={localValue}
                            onChange={e => {
                                if (digitsLimit) {
                                    // Remove non-numeric characters
                                    let inputValue = e.target.value.replace(/[^0-9]/g, '');
                                    if (inputValue.length > +digitsLimit) {
                                        inputValue = inputValue.slice(0, +digitsLimit); // Limits
                                    }
                                    setLocalValue(inputValue);
                                    onChange?.({ ...e, target: { ...e.target, value: inputValue } });
                                }
                                else {
                                    setLocalValue(e.target.value);
                                    onChange?.(e);
                                }
                            }}
                            onBlur={e => { onBlur?.(e); }}
                            onFocus={e => { onFocus?.(e); }}
                            id={id}
                            placeholder={placeholder || ''}
                            name={name}
                            {...a11yProps}
                            ref={mainInputRef} />
                        {type === 'search'
                            && <i
                                role="button"
                                tabIndex={0}
                                aria-label="Search"
                                className="zelpicons zelpicons-search"
                                onClick={onSearchClick}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        onSearchClick();
                                    }
                                }} />}
                    </div>)}

            {type === 'textarea' && <textarea
                id={id}
                name={name}
                value={localValue}
                placeholder={placeholder || ''}
                maxLength={max}
                {...a11yProps}
                onChange={e => {
                    setLocalValue(e.target.value);
                    onChange?.(e);
                }}
                onBlur={e => { onBlur?.(e); }}
                onFocus={e => { onFocus?.(e); }} />}

            {(errors?.length || error) ? (
                <div id={errorId} role="alert">
                    {errors?.length ? errors.map((errorMessage) => (
                        <ErrorMessage
                            key={errorMessage.toString()}>
                            {errorMessage}
                        </ErrorMessage>)) : ''}
                    {error && <ErrorMessage>{error}</ErrorMessage>}
                </div>
            ) : ''}
        </div>
    );
};

export default Input;
